import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCompanies = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		transform: "translate(3.5 2)",
		fill: "currentColor",
		children: [
			/* @__PURE__ */ _jsx("path", { d: "M15.91,0H5.54c-.41,0-.74.33-.74.74v7.18c.05,0,.1,0,.15,0,.82,0,1.55.34,2.07.89v-2.13h2.96v2.96h-2.4c.16.35.24.74.24,1.15,0,.49-.13.96-.35,1.36,1.58,0,2.86,1.29,2.86,2.86v5.01h1.14v-7.41h2.96v7.41h1.48s.01,0,.02,0h.72V.74c0-.41-.33-.74-.74-.74ZM9.98,5.18h-2.96v-2.96h2.96v2.96ZM14.43,9.63h-2.96v-2.96h2.96v2.96ZM14.43,5.18h-2.96v-2.96h2.96v2.96Z" }),
			/* @__PURE__ */ _jsx("path", { d: "M7.46,12.91h-.53c-.52.48-1.22.77-1.98.77s-1.46-.29-1.98-.77h-.53c-1.15,0-2.09.93-2.09,2.08v4.99h9.2v-4.99c0-1.15-.94-2.08-2.09-2.08" }),
			/* @__PURE__ */ _jsx("path", { d: "M4.95,12.85c1.15,0,2.09-.93,2.09-2.08s-.94-2.08-2.09-2.08-2.09.93-2.09,2.08.94,2.08,2.09,2.08" })
		]
	})
});
export default SvgCompanies;
